import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CopyField = ({ label, value, testId, tone = "light" }) => {
  const { t } = useTranslation();
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = value;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setDone(true);
    toast.success(t("common.copied"));
    setTimeout(() => setDone(false), 2000);
  };
  const box = tone === "dark" ? "bg-white/5 border-white/15 text-[var(--cream)]" : "bg-[hsl(var(--card))]";
  return (
    <div>
      {label && <p className="field-label">{label}</p>}
      <div className={`flex items-center gap-2 rounded-xl border p-1.5 ${box}`}>
        <input readOnly value={value} className="flex-1 min-w-0 bg-transparent px-2.5 py-2 text-sm font-mono-admin outline-none" data-testid={`${testId}-input`} onFocus={(e) => e.target.select()} />
        <button onClick={copy} className="btn-gold !px-4 !py-2" data-testid={`${testId}-copy-btn`} aria-label={t("common.copy")}>
          {done ? <Check size={15} /> : <Copy size={15} />}
          <span className="hidden sm:inline">{done ? t("common.copied") : t("common.copy")}</span>
        </button>
      </div>
    </div>
  );
};
